import { Component, computed, effect, Input, Signal } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { EligibilitySite } from '../../models/eligibility-site';
import confetti from 'canvas-confetti';
import { SessionService } from '../../services/session-service';


@Component({
  selector: 'app-sites-progress-bar-component',
  imports: [MatTooltipModule],
  templateUrl: './sites-progress-bar-component.html',
  styleUrl: './sites-progress-bar-component.css',
})
export class SitesProgressBarComponent {
  @Input() sites!: Signal<EligibilitySite[]>;

  public readonly confirmedCount = computed<number>(() => {
    return this.getFiabCount('confirmed');
  });

  public readonly confirmedPercentage = computed<string>(() => {
    return this.getFiabPercentage('confirmed');
  });

  public readonly unsureCount = computed<number>(() => {
    return this.getFiabCount('unsure');
  });

  public readonly unsurePercentage = computed<string>(() => {
    return this.getFiabPercentage('unsure');
  });

  public readonly notFoundCount = computed<number>(() => {
    return this.getFiabCount('not_found');
  });

  public readonly notFoundPercentage = computed<string>(() => {
    return this.getFiabPercentage('not_found');
  });

  public readonly noResultCount = computed<number>(() => {
    return this.getFiabCount('no_result');
  });

  public readonly noResultPercentage = computed<string>(() => {
    return this.getFiabPercentage('no_result');
  });

  public readonly inProgressCount = computed<number>(() => {
    return this.getFiabCount(null);
  });

  public readonly inProgressPercentage = computed<string>(() => {
    return this.getFiabPercentage(null);
  });

  constructor(private sessionService: SessionService) {
    effect(() => {
      const sites = this.sites();

      if (sites.length === 0) {
        return;
      }

      if (sites.filter(site => site.validatedAddressState === 'confirmed').length === sites.length) {
        if (!sessionStorage.getItem('lastConfettiSession') || sessionStorage.getItem('lastConfettiSession') !== sessionService.currentSessionCode()) {
          sessionStorage.setItem('lastConfettiSession', sessionService.currentSessionCode());
          confetti({
            particleCount: 200,
            spread: 200,
            origin: { y: 0.3 }
          });
        }
      }
    });
  }

  getFiabCount(validatedAddressState: string | null) {
    if (this.sites().length == 0) {
      return 0;
    }

    return this.sites().filter(site => site.validatedAddressState === validatedAddressState).length;
  }

  getFiabPercentage(validatedAddressState: string | null): string {
    if (this.sites().length == 0) {
      return '0%';
    }

    return `${this.getFiabCount(validatedAddressState) / this.sites().length * 100}%`;
  }
}
